import React, { useState } from 'react';
import MyMvpsHeader from './MyMvpsHeader';
import MyMvpsList from './MyMvpsList';
import MyMvpsModal from './MyMvpsModal';
import { useIsMobile } from '@repo/common';

const MyMvps = ({ mvpsList }) => {
  const isMobile = useIsMobile();
  const [isSeeAllOpen, setIsSeeAllOpen] = useState(false);

  return (
    <div className='flex flex-col w-full items-start'>
      <MyMvpsHeader
        mvpsList={mvpsList}
        onSeeAll={() => setIsSeeAllOpen(true)}
      />
      <MyMvpsList mvpsList={mvpsList} />

      {isSeeAllOpen && (
        <MyMvpsModal data={mvpsList} onClose={() => setIsSeeAllOpen(false)} $isMobile={isMobile} />
      )}
    </div>
  );
};

export default MyMvps;
